import React, { useState, useCallback, useMemo } from 'react';
import { Radio, Modal, Form, Button, Header } from 'semantic-ui-react';
import VehicleDisplay from './VehicleDisplay';
import styles from './VehicleSelect.module.scss';

const VehicleSelect = ({ onVehicleSelect, policy, confirmMessage, onCancel, message, minimumCreditorsRequired, effectiveDate }) => {
	const [selectedVehicle, setSelectedVehicle] = useState(null);
	const [showConfirm, setShowConfirm] = useState(false);
	const [open, setOpen] = useState(false);

	const onContinue = useCallback(() => {
		var _effectiveDate = new Date(effectiveDate).getTime();
		if (selectedVehicle !== null) {
			var _vehicleFutureEffectiveDate = new Date(selectedVehicle.deleteFutureEffectiveDate).getTime();
			if (_vehicleFutureEffectiveDate !== 0 && _effectiveDate >= _vehicleFutureEffectiveDate) {
				setOpen(true);
				return;
			}
		}
		if (confirmMessage) {
			setShowConfirm(true);
		} else {
			onVehicleSelect(selectedVehicle);
		}
	}, [confirmMessage, effectiveDate, onVehicleSelect, selectedVehicle]);

	const onConfirm = useCallback(() => {
		onVehicleSelect(selectedVehicle);
	}, [onVehicleSelect, selectedVehicle]);

	const vehicles = useMemo(() => {
		let filteredVehicles = policy.vehicles;
		
		if (minimumCreditorsRequired !== null && minimumCreditorsRequired !== undefined) {
			if (minimumCreditorsRequired > 0) {
				filteredVehicles = policy.vehicles.filter((v) => v.creditors && v.creditors.length >= minimumCreditorsRequired);
			}
		}

		if (filteredVehicles.length === 1) {
			setSelectedVehicle(filteredVehicles[0]);
            onContinue();
        }
		
		return filteredVehicles;

    }, [minimumCreditorsRequired, policy.vehicles, onContinue]);

	return (
		<div>
			<Modal open={showConfirm} onClose={() => setShowConfirm(false)} size='tiny'>
				<Modal.Header>Confirm</Modal.Header>
				<Modal.Content>{confirmMessage}</Modal.Content>
				<Modal.Actions>
					<Button id="yesBtn" primary onClick={onConfirm}>
						Yes
					</Button>
					<Button id="noBtn" primary onClick={() => setShowConfirm(false)}>
						No
					</Button>
				</Modal.Actions>
			</Modal>
			<Modal open={open} onClose={() => setOpen(false)} size='tiny'>
				<Modal.Header>Warning</Modal.Header>
				<Modal.Content>{selectedVehicle != null ? 'This vehicle is already scheduled to be deleted from the policy on ' + new Date(selectedVehicle.deleteFutureEffectiveDate).toLocaleDateString() +'.': "" }</Modal.Content>
				<Modal.Actions>
					<Button id="closeBtn" primary onClick={() => setOpen(false)}>
						Close
					</Button>
				</Modal.Actions>
			</Modal>
			<Header>{message}:</Header>
			<Form>
				{vehicles.map((vehicle, i) => {
					return (
						<Form.Field inline key={i}>
							<Radio id={`vehicle_${vehicle.vin}_radio`} checked={vehicle === selectedVehicle} onChange={() => setSelectedVehicle(vehicle)} />
							<label style={{ fontWeight: 'inherit', fontSize: 'inherit' }}>
								<VehicleDisplay vehicle={vehicle} showVin />
							</label>
						</Form.Field>
					);
				})}
			</Form>
			<div className={styles.buttons}>
				<Button id="continueBtn" primary disabled={!selectedVehicle} onClick={onContinue}>
					Continue
				</Button>
				<Button id="cancelBtn" primary onClick={onCancel}>
					Cancel
				</Button>
			</div>
		</div>
	);
};

export default VehicleSelect;
